import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './idb-utility-menu.css.lit';
import { SlotController } from '../../controllers/slot-controller';

/**
 * The IdbUtilityMenu component
 * @element idb-utility-menu
 */
@customElement('idb-utility-menu')
export class IdbUtilityMenu extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  slots = new SlotController(this, true);

  /**
   * Handles swapping out the varying style differences
   * between the utility menu in the header and footer.
   */
  @property({ type: String, attribute: 'variant' })
  variant: 'header' | 'footer' = 'header';

  render(): TemplateResult {
    return html`<div class="${this.variant}-utility"><slot></slot></div>`;
  }
}
